/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React, { ReactNode } from 'react';
import { ToastProvider } from './ToastProvider';
import { NotificationProvider } from '@/shared/ui/components/basic/Notifications';
import { SonnerProvider } from '@/shared/ui/components/shadcn';

interface UIProviderProps {
  children: ReactNode;
}

const UIProvider: React.FC<UIProviderProps> = ({ 
  children, 
}) => {
  return (
    <NotificationProvider position="top-right">
      <ToastProvider>
        {children}
        <SonnerProvider />
      </ToastProvider>
    </NotificationProvider>
  );
};

export default UIProvider; 